import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Spinner, Form } from "react-bootstrap";
import { getContactList, updateContactStatus } from "../../../redux/setting/action";
import CommonPagination from "../../Common/Pagination/CommonPagination";
import { formatDateTime } from "../Order/shared/orderFormat";




const ContactListPage = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);

  const customerList = useSelector((state) => state.reusableSlice?.CustomerList);
  const pagination = useSelector((state) => state.reusableSlice?.CustomerList.pagination_meta);
  const contactData = customerList?.contact_list || [];


  const [params, setParams] = useState({
      page: 1,
    });


  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      await dispatch(getContactList(params));
      setLoading(false);
    };
    fetchData();
  }, [dispatch, params]);

  // handle dropdown change
  const handleStatusChange = async (id, newStatus) => {
    const payload = { id, status: Number(newStatus) };
    await dispatch(updateContactStatus(payload));
    // reload after update
    await dispatch(getContactList(params));
  };


    const handlePageChange = (newPage) => {
    setParams((prevParams) => ({
      ...prevParams,
      page: newPage,
    }));
  };



  return (
    <div className="card-head order-card">
      <h2>Contact List</h2>
      {loading ? (
        <div className="d-flex justify-content-center my-4">
          <Spinner animation="border" />
        </div>
      ) : (
        <>
          {contactData.length > 0 ? (
            <div className="table-responsive">
              <table className="table table-bordered table-hover mt-3">
                <thead className="thead-dark">
                  <tr>
                    <th>#</th>
                    <th>Received</th>
                    <th>Full Name</th>
                    <th>Email</th>
                    <th>Phone</th>
                    <th>Subject</th>
                    <th>Message</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {contactData.map((contact, index) => (
                    <tr key={contact.id || index}>
                      {/* Numbered across pages: row 1 of page 2 is 11, not 1 again. */}
                      <td>
                        {((pagination?.current_page || 1) - 1) *
                          (pagination?.per_page || contactData.length) +
                          index +
                          1}
                      </td>
                      {/* Sent in UTC; shown in Riyadh time, like orders. */}
                      <td className="text-nowrap">{formatDateTime(contact.created_on)}</td>
                      <td>{contact.full_name || "-"}</td>
                      <td>{contact.email_id || "-"}</td>
                      {/* The backend sends `phone`: what the sender typed, else their profile's number. */}
                      <td dir="ltr">{contact.phone || "-"}</td>
                      <td>{contact.subject || "-"}</td>
                      <td>{contact.message?.trim() || "-"}</td>
                      <td>
                        <Form.Select
                          size="sm"
                          value={contact.status}
                          onChange={(e) =>
                            handleStatusChange(contact.id, e.target.value)
                          }
                        >
                          <option value="1">Open</option>
                          <option value="2">Close</option>
                        </Form.Select>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="pagination-section">
                     <select
              className="form-select"
              value={params.per_page || 10}
              onChange={(e) =>
                setParams((prev) => ({
                  ...prev,
                  page: 1, // reset to first page when changing per_page
                  per_page: e.target.value,
                }))
              }
              style={{ width: "100px" }}
            >
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
                        <CommonPagination
                          currentPage={pagination.current_page}
                          totalPages={pagination.pages}
                          onPageChange={handlePageChange}
                        />
                    
                    </div>
            </div>
          ) : (
            <p className="text-muted mt-3">No contact data found.</p>
          )}
        </>
      )}
    </div>
  );
};

export default ContactListPage;
